import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import get from 'lodash/get';
import values from 'lodash/values';
import isUndefined from 'lodash/isUndefined';

import ReportIcon from '@mui/icons-material/Description';
import {
  ListItem,
  ListItemIcon,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  Typography,
  ListItemText,
  Grid,
  Paper,
} from '@mui/material';

import {
  READ,
  ZONE_DEPLOYMENT_TABLE,
  DEPLOYMENT_PROGRESS_PAGE,
  REPAIR_TICKET_REPORT,
  REPAIRS_BY_CATEGORY_REPORT,
  INVENTORY_REPORT,
  RIDE_REPORT,
} from '../../../access';

const styles = {
  root: {
    width: '80%',
    marginLeft: 'auto',
    marginRight: 'auto',
    overflowX: 'auto',
  },
  cleanUrl: {
    textDecoration: 'none',
    color: 'black',
  },
  title: {
    flex: '0 0 auto',
  },
};

const REPORTS = {
  DEPLOYMENT_PROGRESS: {
    route: 'deployProgress',
    name: 'Deployment Progress',
    accessName: DEPLOYMENT_PROGRESS_PAGE,
    description: 'Deployment progress for all Zones within a Market for a specified date',
  },
  ZONE_DEPLOYMENT: {
    route: 'deploys',
    name: 'Zone Deployment',
    accessName: ZONE_DEPLOYMENT_TABLE,
    description: 'Deployment for all Zones within a Market for a specified date',
  },
  REPAIR_TICKETS: {
    route: 'repairTickets',
    name: 'Vehicle Repairs',
    accessName: REPAIR_TICKET_REPORT,
    description: 'Repair Tickets by Market, Brand within a specified date range',
  },
  REPAIRS_BY_CATEGORY_REPORT: {
    route: 'repairsByCategory',
    name: 'Repairs By Category Report',
    accessName: REPAIRS_BY_CATEGORY_REPORT,
    description: 'Count of Repairs by Category, Market, Brand within a specified date range',
  },
  INVENTORY: {
    route: 'inventory',
    name: 'Inventory',
    accessName: INVENTORY_REPORT,
    description: 'Inventory by Market, Brand, Type within a specified date range',
  },
  TRIPS: {
    route: 'rides',
    name: 'Trips',
    accessName: RIDE_REPORT,
    description: 'Trip by Market, Brand, Type within a specified date range',
  },
};

const baseUrl = '/operator/reports/';

function getListItem(can, report) {
  return (
    can(READ, report.accessName) && (
      <TableRow key={report.name}>
        <TableCell>
          <Link
            to={`${baseUrl}${report.route}`}
            style={styles.cleanUrl}
          >
            <ListItem button>
              <ListItemIcon>
                <ReportIcon />
              </ListItemIcon>
              <ListItemText disableTypography>
                {report.name}
              </ListItemText>
            </ListItem>
          </Link>
        </TableCell>
        <TableCell>
          {report.description}
        </TableCell>
      </TableRow>
    )
  );
}

function BaseReportsPage({ currentWrangler }) {
  const can = get(currentWrangler, 'access.can');

  if (isUndefined(can)) {
    return (
      <Paper>
        <Grid container direction="column" justifyContent="center" alignItems="center" />
      </Paper>
    );
  }
  return (
    <Paper style={styles.root} sx={{ mt: 3 }}>
      <Grid style={styles.title} sx={{ pl: 4, pt: 3 }}>
        <Typography variant="h6" id="tableTitle">
          Reports
        </Typography>
      </Grid>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center">Report Type</TableCell>
            <TableCell>Description</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {values(REPORTS).map((report) => getListItem(can, report))}
        </TableBody>
      </Table>
    </Paper>
  );
}

const mapStateToProps = ({ wranglers }) => ({
  currentWrangler: wranglers.currentWrangler,
});

const ReportsPage = connect(mapStateToProps)(withRouter(BaseReportsPage));

export { BaseReportsPage };
export default ReportsPage;
